"use strict";

(function () {
  'use strict';

  angular.module('lr.Properties', ['lr.Devices', 'lr.Flag', 'lm.Request', 'lr.properties.filters']);
})();